export default __webpack_public_path__ + "static/media/Path3530.625bd2c9.svg";